export default __webpack_public_path__ + "static/media/2003.f05ec4aa.png";